import React from "react";
import WhatsAppIcon from "./WhatsAppIcon";
import { whatsappLink } from "../whatsapp";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={whatsappLink(
        "Hi Organo Mushroom 👋\n\nI'd like to know more about your products."
      )}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Organo Mushroom on WhatsApp"
      className="fixed bottom-6 left-6 z-30 inline-flex items-center gap-2 rounded-full bg-[#1FA855] hover:bg-[#178a45] text-white px-5 py-4 shadow-[0_12px_30px_rgba(31,168,85,0.35)] hover:shadow-[0_16px_38px_rgba(31,168,85,0.45)] transition-all"
    >
      <span className="relative grid place-items-center h-6 w-6">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
        <WhatsAppIcon className="h-6 w-6 relative" />
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-wide">
        Chat on WhatsApp
      </span>
    </a>
  );
}
